import React from 'react';
import { medSpaTreatments } from '../data/procedures';
export function MedSpa() {
  return <section id="med-spa" className="bg-white py-20 lg:py-28" data-id="element-89" data-mp="216uv4c87ajy5">
      <div className="mx-auto max-w-shell px-6 lg:px-10" data-id="element-90" data-mp="219gxlxg8i99i">
        <div className="max-w-2xl" data-id="element-91" data-mp="1w9clejmd00p3">
          <p className="text-[0.65rem] uppercase tracking-overline text-champagne-dark" data-id="element-92" data-mp="1wadwgo3dkn6t">
            Non-Surgical
          </p>
          <h2 className="mt-5 text-3xl font-light leading-[1.15] tracking-[-0.02em] text-ink sm:text-[2.75rem]" data-id="element-93" data-mp="2owp4gjtb9qdn">
            The med spa
          </h2>
          <p className="mt-6 text-base leading-[1.85] text-ink-soft" data-id="element-94" data-mp="2jyf6k1g7cboc">
            Injectables and device treatments performed by medical providers under Dr.
            Sara&rsquo;s supervision — for maintenance between surgeries, or as a complete
            plan on their own.
          </p>
        </div>

        <div className="mt-12 grid gap-8 sm:grid-cols-2 lg:mt-16 lg:grid-cols-3 lg:gap-10" data-id="element-95" data-mp="37orevdfd0afg">
          {medSpaTreatments.map(treatment => <article key={treatment.name} className="group flex flex-col" data-id="element-96" data-mp="3oj3jam6vkcvn">
              <div className="overflow-hidden bg-sand" data-id="element-97" data-mp="3olzkcje0rhob">
                <img src={treatment.image} alt={treatment.name} className="h-64 w-full object-cover transition-transform duration-300 ease-soft group-hover:scale-[1.03]" data-id="element-98" data-mp="3thev32gqcxgi" />
              </div>
              <h3 className="mt-6 text-xl font-normal tracking-[-0.01em] text-ink" data-id="element-99" data-mp="35tf6o96w5j53">
                {treatment.name}
              </h3>
              <p className="mt-3 text-[0.95rem] leading-[1.8] text-ink-soft" data-id="element-100" data-mp="3at01q8ixx7cj">
                {treatment.description}
              </p>
              <p className="mt-auto pt-6 text-xs uppercase tracking-[0.12em] text-ink-muted" data-id="element-101" data-mp="2vxc26wokh8ez">
                {treatment.detail}
              </p>
            </article>)}
        </div>
      </div>
    </section>;
}